import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import { PayrollUpdateMyCustomFieldsResponse, PayrollUpsertMode } from '../types';

// Schema: payrollUpdateMyCustomFields(fields, mode, effectiveFrom) returns PayrollEmployeeFields!
const updateMyMutation = gql`
  mutation PayrollUpdateMyCustomFields($fields: JSON!, $mode: PayrollUpsertMode) {
    payrollUpdateMyCustomFields(fields: $fields, mode: $mode) {
      userId
      fields
    }
  }
`;

export const updateMyCustomFields = (variables: {
  fields: Record<string, unknown>;
  mode: PayrollUpsertMode;
}) =>
  graphQLApi<
    PayrollUpdateMyCustomFieldsResponse,
    { fields: Record<string, unknown>; mode: PayrollUpsertMode }
  >({
    query: updateMyMutation,
    queryVariables: variables,
  });
